import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import getIsLoyaltyAccountClosed from './getIsLoyaltyAccountClosed'
import getIsLoyaltyAccountLoading from './getIsLoyaltyAccountLoading'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

// The bonus is paid in Société points, so a closed Société account can't receive it. Waits for the
// account read, or the bonus flashes up for a closed account until the read fails.
function getIsLoyaltyLuxPlusRenewalBonusEnabled(state: App.State): boolean {
  return getIsLoyaltyEnabled(state)
    && !getIsLoyaltyAccountClosed(state)
    && !getIsLoyaltyAccountLoading(state)
    && state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.loyaltyLuxPlusRenewalReward]
}

export default getIsLoyaltyLuxPlusRenewalBonusEnabled
